import { Avatar, Button, Stack, Typography } from '@mui/material';
import { ACTION_TYPE } from 'models';
import { AC_BASE_REQUEST_SITTER } from 'models/overview';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'routers/routes';
import { useAppDispatch } from 'store/hook';
import { updateACRequestSitterStatus } from 'store/reducers/overview';
import { theme } from 'theme';
import { pluralString, toCapitalize } from 'utils';

interface SitterPreviewItemProps {
  acBaseRequestSitter: AC_BASE_REQUEST_SITTER;
}

export const SitterPreviewItem = ({
  acBaseRequestSitter,
}: SitterPreviewItemProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing={1.25}>
        {acBaseRequestSitter.sitter?.profile_picture ? (
          <img
            src={acBaseRequestSitter.sitter.profile_picture}
            alt="sitter profile"
            style={{ width: 50, height: 50, borderRadius: '50%' }}
          />
        ) : (
          <Avatar sx={{ width: 50, height: 50 }} />
        )}

        <Stack spacing={0.5}>
          <Typography
            sx={{ fontWeight: 600 }}
            variant="Web_Label_16"
            color={
              acBaseRequestSitter.status === ACTION_TYPE.REJECTED
                ? theme.palette.text.disabled
                : theme.palette.primary.main
            }
          >
            {toCapitalize(acBaseRequestSitter.sitter?.User?.first_name) +
              ' ' +
              toCapitalize(acBaseRequestSitter.sitter?.User?.last_name)}
          </Typography>
          <Typography variant="Small_Body_12" color="grey1.light">
            Total Exp on App:{' '}
            {pluralString(
              'hour',
              acBaseRequestSitter.sitter
                ? acBaseRequestSitter.sitter?.hours_worked
                : 0,
            )}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        direction={{ xs: 'column-reverse', md: 'row' }}
        spacing={{ xs: 0.5, md: 2 }}
        alignItems="center"
      >
        <Typography variant="Web_Label_14" color={theme.palette.red.light}>
          {toCapitalize(acBaseRequestSitter.status)}
        </Typography>
        <Button
          variant="contained"
          // disabled={acBaseRequestSitter.status === ACTION_TYPE.REJECTED}
          onClick={() => {
            dispatch(
              updateACRequestSitterStatus(
                acBaseRequestSitter.status as ACTION_TYPE,
              ),
            );
            navigate(
              APP_ROUTES.SITTER_DETAIL.to(acBaseRequestSitter.sitter.User.id),
            );
          }}
          sx={{
            height: '35px',
            fontSize: 12,
            paddingY: 0.75,
          }}
        >
          View
        </Button>
      </Stack>
    </Stack>
  );
};

export default SitterPreviewItem;
